<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import Swal from "sweetalert2"
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/monitoramento_anim.json'

import {clientesChart1, clientesChart2 } from "../components/data-simulados";
import moment from "moment/moment";
import { DxColumn, DxColumnChooser, DxColumnFixing, DxDataGrid, DxExport, DxFilterRow, DxGrouping, DxGroupPanel,
  DxPager, DxRemoteOperations, DxStateStoring
} from "devextreme-vue/data-grid";
import DxToolbar, {DxItem} from "devextreme-vue/toolbar";
import DxButton from "devextreme-vue/button";
import {Workbook} from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import {saveAs} from "file-saver-es";
import {getBaseUrl} from "@/helpers/baseUrl";
//import Multiselect from "@vueform/multiselect";

export default {
  page: {
    title: "Monitoramento XML",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    DxColumn, DxItem, DxGroupPanel, DxButton, DxStateStoring, DxGrouping, DxColumnFixing, DxFilterRow, DxColumnChooser,
    DxToolbar, DxRemoteOperations, DxPager, DxExport, DxDataGrid, Layout, PageHeader, Loader, Vue3Lottie }, /*Multiselect*/

  data() {
    return {
      animationJson,
      title: 'Relatórios de Estoque',
      items: [
        {
          text: 'Estoque',
          href: '/',
        },
        {
          text: 'Relatórios',
          active: true,
        },
      ],
      loadingList: true,
      estoqueList: null,
      monitorasList: null,
      updating: false,
      periodo: null,
      periodoPesq: false,
      cliChart1: clientesChart1,
      cliChart2: clientesChart2,
      pesqTextFilter: '',
      showModalPeriodo: false,
      submittedPeriodo: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      selectRelat: "RS",
      optionsRelat: [
        { value: "RE", text: "Relatório de Estoque" },
        { value: "RS", text: "Relatório Saldo de Estoque" }
      ],
      picoArmazenagem: 0
    }
  },

  computed: {
    dataGrid: function () {
      return this.$refs.dataGridRefKey.instance;
    },

    maxQtdCompra() {
      if(!this.estoqueList || this.estoqueList.length === 0) {
        return 0;
      }
      return Math.max(...this.estoqueList.map(item => item.qtd_total_compra || 0));
    }
  },

  mounted() {
    console.log('mounted')

    this.dtIniFiltro = 
      localStorage.getItem('filtros') ? 
      JSON.parse(localStorage.getItem('filtros')).movdi : 
      moment().format('YYYY-MM-DD')

    this.dtFimFiltro = 
      localStorage.getItem('filtros') ? 
      JSON.parse(localStorage.getItem('filtros')).movdf : 
      moment().format('YYYY-MM-DD')

    this.atualizaDataList()
  },

  methods: {

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      console.log(JSON.parse(localStorage.getItem('filtros')))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    atualizaDataList(){
      console.log("atualizaDataList")

      this.loadingList = true
      const filtros = JSON.parse(localStorage.getItem("filtros"))

      if (!filtros) {
        let perIniPadrao = moment().startOf('month').format('YYYY-MM-DD')
        let perFimPadrao = moment().format('YYYY-MM-DD')

        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
        this.periodoPesq = filtros['tipoFilter']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        let perIniPadrao = moment().startOf('month').format('YYYY-MM-DD')
        let perFimPadrao = moment().format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      api.get(`${getBaseUrl()}api/relatestoque`, {
        params: {
          'tp': this.periodoPesq,
          'dataInicio': this.dtIniFiltro,
          'dataFim': this.dtFimFiltro,
          'fm': this.periodo,
          //'relat': this.selectRelat //POSTERIOMENTE ADICIONAR POSSIBILIDADE DO TIPO DE RELATÓRIO
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        //console.log(JSON.stringify(res.data))

        this.title = `Relatórios de Estoque: ${this.formatDate(this.dtIniFiltro)} - ${this.formatDate(this.dtFimFiltro)}`
        this.loadingList = false

        if(res.data.success) {
          this.estoqueList = res.data.dataListEstoque
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2500
          })
        }
      });
    },

    carregouGrid(e) {
      console.log("carregouGrid");
      console.log(e);
    },

    onExporting(e) {
      console.log("onExporting");
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("plan1");
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              this.title + ".xlsx"
          );
        });
      });
      e.cancel = true;
    },

    refeFormTable() {
      console.log("refeFormTable");
      this.dataGrid.state(null);
    },

    confirmaPeriodoPesq() {
      console.log('confirmaPeriodoPesq')

      localStorage.setItem('filtros', JSON.stringify({
        'tipoFilter': this.periodoPesq
      }))

    },

    mudouPeriodo(){
      console.log('mudouPeriodo')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      // this.carregarDados()
    },

    onRowPrepared(e) {
      if (e.rowType === "data" && e.data.qtd_total_compra) {
          const valorAtual = parseFloat(e.data.qtd_total_compra)
          
          if(valorAtual > 0  && valorAtual === this.maxQtdCompra){
            e.rowElement.style.backgroundColor = 'rgba(33,78,0,0.5)'
            e.rowElement.style.fontWeight = 'bold';
          }
      }
    },

    formatDecimal(value){
      let value_n = parseFloat(value);
      return value_n .toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2});
    },

    formatDate(value) {
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },
  },


}
</script>

<template>
  <Layout>
    <span class="float-end" style="z-index: 1; position: absolute; top: 10px; right: 140px;">
      <Vue3Lottie :animationData="animationJson" :height="250" :width="250" />
    </span>

    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true" style="cursor: pointer;"/>

    <Loader v-if="loadingList" style="min-height: 300px;">
    </Loader>


    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row" v-if="!updating">

              <!--POSTERIORMENTE SE NECESSÁRIO REATIVAR CLASSIFICAÇÃO DE TIPO DE RELTÓRIO-->
              <!--<div class="col-sm-12">
                <div class="col-sm-3 mb-3">
                  <label>Selecionar o relatório desejado:</label>
                  <multiselect id="selectRelat"
                               @select="atualizaDataList"
                               v-model="selectRelat"
                               placeholder="Selecione o relatório desejado"
                               :options="optionsRelat"
                               :searchable="false"
                               label="text"
                               track-by="text"
                               value-prop="value">
                    <template #option="slotProps">
                      <div class="row">
                        <div>
                          <span class="mx-2" >
                            {{ slotProps.option.text }}
                          </span>
                        </div>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>-->
            </div>

            <div class="table-responsive" v-if="!loadingList">
              <div>
                <DxToolbar>
                  <DxItem location="before" widget="dxButton">
                    <DxButton
                        icon="refresh"
                        hint="Redefinir formatação de tabela para padrão"
                        :on-click="refeFormTable"
                    />
                  </DxItem>
                </DxToolbar>
              </div>

              <div class="mt-0" v-if="!updating">
                <DxDataGrid
                    ref="dataGridRefKey"
                    :data-source="estoqueList"
                    :show-borders="true"
                    :focused-row-enabled="true"
                    :keyExpr="'data'"
                    :column-auto-width="true"
                    :show-row-lines="true"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :row-alternation-enabled="true"
                    @content-ready="carregouGrid"
                    @exporting="onExporting"
                >
                <!--@row-prepared="onRowPrepared"-->
                
                  <DxRemoteOperations
                      :filtering="true"
                      :paging="true"
                      :sorting="true"
                      :summary="true"
                      :grouping="false"
                      :group-paging="false"
                  />

                  <DxColumnChooser :enabled="true" />
                  <DxColumnFixing :enabled="true" />
                  <DxFilterRow :visible="true" />

                  <DxExport
                      :enabled="true"
                      :allow-export-selected-data="true"
                  />
                  <DxStateStoring
                      :enabled="true"
                      type="sessionStorage"
                      storage-key="strWmsOsEntradaList"
                  />

                  <DxGroupPanel :visible="false" />
                  <DxGrouping />
                    <DxColumn
                        data-field="data"
                        caption="Data"
                        data-type="date"
                        format="dd/MM/yyyy"
                        alignment="left"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="qtd_total_compra"
                        caption="Qtd. Total Compras"
                        data-type="text"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="vl_brt_medio_compra"
                        caption="R$ Bruto Médio Compras"
                        data-type="text"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="vl_liq_medio_compra"
                        caption="R$ Bruto Médio Compras"
                        data-type="text"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="vlrtotal_brt_compra"
                        caption="R$ Bruto Total Compras"
                        data-type="text"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="vlrtotal_liq_compra"
                        caption="R$ Líquido Total Compras"
                        data-type="text"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="qtd_total_saida"
                        caption="Qtd. Total Vendas"
                        data-type="text"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="vl_brt_medio_saida"
                        caption="R$ Bruto Médio Vendas"
                        data-type="text"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="vl_liq_medio_saida"
                        caption="R$ Bruto Médio Vendas"
                        data-type="text"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="vlrtotal_brt_saida"
                        caption="R$ Bruto Total Vendas"
                        data-type="text"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="vlrtotal_liq_saida"
                        caption="R$ Líquido Total Vendas"
                        data-type="text"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />



                  <DxPager
                      :visible="true"
                      :show-page-size-selector="true"
                      :allowed-page-sizes="[10, 30, 50, 100]"
                      :show-navigation-buttons="true"
                      :show-info="true"
                  />
                </DxDataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                  class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                  class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>
  </Layout>
</template>

